export const PLAN_OPTIONS = [
  { label: 'All Plans', value: '' },
  { label: 'Free (Ads)', value: 'free' },
  { label: 'Trial', value: 'trial' },
  { label: 'Single Premium', value: 'single' },
  { label: 'Duo Premium', value: 'duo' },
  { label: 'Family Premium', value: 'family' },
];

export const STATUS_OPTIONS = [
  { label: 'All Statuses', value: '' },
  { label: 'Paid', value: 'paid' },
  { label: 'Payment Failed', value: 'failed' },
  { label: 'Pending Payment', value: 'pending' },
  { label: 'Payment Refunded', value: 'refunded' },
  { label: 'Plan Cancelled', value: 'cancelled' },
  { label: 'Unpaid-Free)', value: 'not_required' },
];

export const SORT_OPTIONS = [
  { label: 'Sub Date', value: 'subscriptionDate' },
  { label: 'Renewal Date', value: 'renewalDate'},
  { label: 'Amount', value: 'amount' },
  { label: 'Status', value: 'status' },
  { label: 'Plan', value: 'plan' },
];

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100]